<template>
	<div class="items">
		<div class="left" :style='{"background-image":"url("+planid.pimg+")"}'>
			<!-- <el-image :src="[planid.pimg]" :fit="contain"></el-image> -->
			<!-- <img :src="planid.pimg" /> -->
		</div>
		<div class="right">
			<div class="name">
				<div class="no"><span>{{index+1}}</span></div>
				<div class="itemname"><span>{{planid.name}}</span></div>
			</div>
			<template v-if="plantype==2">
				<div class="count">
					<span class="txtcolor" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
					<span class="txtcolor" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
				</div>
			</template>
			<template v-if="plantype==0">
				<template v-if="this.$pstore.state.finaldata[index].radio=='count'">
					<div class="count">
						<span class="txtcolor" v-if="planid.count!=0">{{$t('schedule.playCount')}}:{{planid.count}}</span>
						<span class="txtcolor" v-else>{{$t('schedule.playCount')}}:{{planid.my_countvalue}}</span>
					</div>
				</template>
				<template v-if="this.$pstore.state.finaldata[index].radio=='time'">
					<div class="count">
						<span class="txtcolor" v-if="planid.time!=0">{{$t('schedule.playTimes')}}:{{`${planid.time}:00:00`}}</span>
						<span class="txtcolor" v-else>{{$t('schedule.playTimes')}}:{{`${planid.my_timevalue}`}}</span>
					</div>
				</template>
			</template>
		</div>
		<!-- <div class="delete" @click.stop="deleteitems">
			
		</div> -->
		<div class="dele" @click.stop="deleteitems">
			{{$t('terminal.delete')}}
		</div>
	</div>
</template>

<script>
	export default {
		name: "ProgramItems",
		props: {
			planid: {
				type: Object
			},
			index: {
				type: Number
			},
			plantype: {
				type: Number
			}
		},
		methods: {
			deleteitems() {
				this.$pstore.commit('deleteitems', this.index)
				// this.$pstore.commit('confirmCurrentindex', this.index)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.items {
		height: 12%;
		min-height: 55px;
		width: 100%;
		padding-top: 5px;
		display: flex;
		//justify-content: space-between;
		margin-top: 1%;
		// position: relative;
	}

	.left {
		//width: 44%;
		width: 105px;
		min-width: 105px;
		height: 100%;
		margin-left: 5px;
		background-color: black;
		background-size: 100% 100%;
		overflow: hidden;
		background-position: center;
		background-repeat: no-repeat;
		/* overflow: hidden; */
		/* 	display: table-cell;
		vertical-align: middle;
		text-align: center; */
	}
	.right {
		//width: 50%;
		//flex:1;
		width: calc(100% - 105px - 20px - 5px - 10px);
		padding-left: 5px;
		padding-right: 5px;
		display: flex;
		flex-direction: column;
	}

	.dele {
		background-color: red;
		height: calc(100% + 5px);
		transform: translateY(-5px);
		//width: 6%;
		width: 20px;
		background-image: linear-gradient(270deg, #ff907e 0%, #ff7878 45%, #ff5f72 100%), linear-gradient(#ffffff, #ffffff);
		background-blend-mode: normal, normal;
		color: #fff;
		border-radius: 0px 2px 2px 0px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 14px;
		line-height:24px;
		writing-mode:tb-rl;
		//padding-left: 3px;
		//padding-right: 3px;
		
		.sp{
			height: 40px;
		}
	}

	.name {
		height: 50%;
		display: flex;
		flex-basis: 50%;
		align-items: center;
		
	}

	.count {
		height: 50%;
		position: relative;
	}

	.count span {
		position: absolute;
		left: 0;
		bottom: 0;
	}

	.no {
		background-color: #15aff7;
		text-align: center;
		/* line-height: 100%; */
		border-radius: 2px;
		/* flex-basis: 20%;
		height: 50%; */
		width: 20px;
		height: 20px;
		padding: 1px;
		color: white;
	}

	.no span {
		font-family: PingFang-SC-Regular;
		line-height: 20px;
		color: #ffffff;
	}

	.itemname {
		// flex-basis: 80%;
		overflow:hidden;
		padding-left: 2%;
		font-family: PingFang-SC-Regular;
		font-size: 14px;
		height: 20px;
		line-height: 16px;
		color: #617883;
		text-overflow: ellipsis;
		width: calc(100% - 20px);
	}

	.txtcolor {
		font-family: PingFang-SC-Regular;
		font-size: 16px;
		font-stretch: normal;
		line-height: 16px;
		letter-spacing: 0px;
		color: #617883;
	}

	.delete {
		width: 1vw;
		height: 1vw;
		border-radius: 50%;
		background-image: url(~@/assets/images/public/public_close.png);
		background-size: 100%;
		background-position: center;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 9;
	}
</style>
